import * as actionTypes from './actionsTypes';

export const setAlertInfo = (state) => {

  return {
    type: actionTypes.SETALERTINFO,
    data: state,
  };
};